<template>
  <div>
    <v-form lazy-validation ref="form">
      <v-row>
        <v-col cols="12" sm="12" md="6" xl="3" v-if="!hidden">
          <v-menu
            v-model="menuStartDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="form.startDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                label="Start Date"
              ></v-text-field>
            </template>
            <v-date-picker v-model="form.startDate" @input="menuStartDate = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="6" xl="3" v-if="!hidden">
          <v-menu
            v-model="menuEndDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="form.endDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                label="End Date"
              ></v-text-field>
            </template>
            <v-date-picker v-model="form.endDate" @input="menuEndDate = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="6" xl="3">
          <v-text-field
            outlined
            flat
            dense
            background-color="white"
            v-model.number="form.month"
            label="Month"
            @change="onChangeMonth"
            :rules="[
              v => !!v || 'Month is required',
              v => v >= 5 || 'Month must be more than equal 5',
            ]"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="form.items"
            dense
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.type="{ item }">
              {{ item.type && item.type.text ? item.type.text : item.type }}
            </template>
            <template v-slot:item.month="{ item }">
              <v-select
                outlined
                flat
                dense
                background-color="white"
                v-model.number="item.month"
                :items="listMonth"
              ></v-select>
            </template>
            <template v-slot:item.day="{ item }">
              <v-select
                outlined
                flat
                dense
                background-color="white"
                v-model.number="item.day"
                :items="listDay"
              ></v-select>
            </template>
            <template v-slot:item.amount="{ item }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model.number="item.amount"
                persistent-hint
                :hint="formatPrice(item.amount)"
              ></v-text-field>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="text-right">
        <v-col cols="12">
          <v-btn color="primary" @click="generatePreview" block large>
            Generate Preview
            <v-icon right>mdi-file-eye</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "cash-budget-v2",
  computed: {
    listDay() {
      let array = [];
      for (let i = 0; i <= 30; i++) {
        array.push(i + 1);
      }
      return array;
    },
  },
  data() {
    return {
      menuStartDate: false,
      menuEndDate: false,
      hidden: true,
      form: {
        items: [],
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment()
          .add(5, "months")
          .endOf("month")
          .format("YYYY-MM-DD"),
        month: 5,
      },
      listMonth: [
        { text: "Januari", value: 1 },
        { text: "Februari", value: 2 },
        { text: "Maret", value: 3 },
        { text: "April", value: 4 },
        { text: "Mei", value: 5 },
        { text: "Juni", value: 6 },
        { text: "Juli", value: 7 },
        { text: "Agustus", value: 8 },
        { text: "September", value: 9 },
        { text: "Oktober", value: 10 },
        { text: "November", value: 11 },
        { text: "Desember", value: 12 },
      ],
      headers: [
        {
          id: 1,
          text: "Type",
          sortable: false,
          value: "type",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Month",
          value: "month",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: "Day",
          value: "day",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: "Amount",
          value: "amount",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    formatPrice(value) {
      if (value === null || value === undefined || value === 0) return "-";
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    onChangeMonth(val) {
      this.form.endDate = moment(this.form.startDate)
        .add(val, "months")
        .endOf("month")
        .format("YYYY-MM-DD");
    },
    async generatePreview() {
      if (this.$refs.form.validate()) {
        this.$store.commit("SET_LOADER", true);
        try {
          // Perform data fetch to ensure we have data before navigating
          await this.$store.dispatch("report/cashBudgetV2", this.form);

          // Navigate to preview page with necessary query params for detail/excel calls
          this.$router.push({
            path: "/report/cash-budget/preview",
            query: {
              startDate: this.form.startDate,
              endDate: this.form.endDate,
              month: this.form.month,
            },
          });
        } catch (e) {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Gagal memproses preview",
          });
        } finally {
          this.$store.commit("SET_LOADER", false);
        }
      }
    },
    async getCashBudgetItems() {
      this.$store.commit("SET_LOADER", true);
      try {
        const res = await this.$store.dispatch("report/cashBudgetItem");
        this.form.items = res.data;
      } catch (e) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Gagal memuat konfigurasi",
        });
      } finally {
        this.$store.commit("SET_LOADER", false);
      }
    },
  },
  mounted() {
    this.getCashBudgetItems();
  },
};
</script>

<style scoped></style>
